import {LogoSuite} from '@primer/react-brand/esm'

import {LogoSuiteMap} from '@github-ui/swp-core/components/contentful/ContentfulLogoSuite'

import Styles from './LogoMarquee.module.css'

export interface LogoMarqueeProps {
  title: string
  logos: string[]
}

export const defaultProps: Partial<LogoMarqueeProps> = {}

export const LogoMarquee = (props: LogoMarqueeProps) => {
  const initializedProps: LogoMarqueeProps = {...defaultProps, ...props}
  const {title, logos} = initializedProps

  return (
    <LogoSuite className={Styles.LogoMarquee} hasDivider={false}>
      <LogoSuite.Heading as="h2" visuallyHidden>
        {title}
      </LogoSuite.Heading>
      <LogoSuite.Logobar marquee marqueeSpeed="slow" variant="muted">
        {logos.map(name => {
          const Logo = LogoSuiteMap[name]
          if (!Logo) throw new Error(`Unknown logo: ${name}`)
          return <Logo key={name} />
        })}
      </LogoSuite.Logobar>
    </LogoSuite>
  )
}
